import { Component, OnInit, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { TipoAcaoOperacao, TipoAcaoRefTo, getAcaoDescricaoTxt } from 'src/app/enums/tipo-acao-log'
import { DatePipe } from '@angular/common'
import { ConsultaLogService } from 'src/app/services/consulta-log.service'
import { LogEntry } from 'src/app/models/log-entry'
import { MatDialog } from '@angular/material/dialog'
import { LogDetalhesComponent } from './log-detalhes/log-detalhes.component'
import { tap } from 'rxjs/internal/operators/tap'

@Component({
  selector: 'app-consulta-log',
  templateUrl: './consulta-log.component.html',
  styleUrls: ['./consulta-log.component.css'],
  standalone: false
})
export class ConsultaLogComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  lastPage: number = 0
  lastPageSize: number = 25
  totalElements: number = 0

  tipoAcaoOperacao = TipoAcaoOperacao
  tipoAcaoRefTo = TipoAcaoRefTo

  nivelLogFC: FormControl = new FormControl('')
  dataInicialFC: FormControl = new FormControl()
  dataFinalFC: FormControl = new FormControl()
  dataMaxima: Date = new Date()
  usuarioFC: FormControl = new FormControl('')
  idFC: FormControl = new FormControl('')
  tipoAcaoOperacaoFC: FormControl = new FormControl('')
  tipoAcaoRefToFC: FormControl = new FormControl('')

  registro: number | null = null
  ipAddr: string | null = null
  msgSelecionado: string = ''

  colunasGrid: string[] = ['nivel', 'data', 'ip', 'username', 'acao', 'action']
  dataSource: MatTableDataSource<LogEntry> = new MatTableDataSource()

  datepipe: DatePipe = new DatePipe('pt-BR')

  constructor(private consultaLogService: ConsultaLogService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.nivelLogFC.setValue('TODOS')
    this.tipoAcaoOperacaoFC.setValue('TODOS')
    this.tipoAcaoRefToFC.setValue('TODOS')

    this.lastPage = this.paginator.pageIndex
    this.lastPageSize = this.paginator.pageSize

    this.paginator?.page
      .pipe(
        tap(() => {
          if (this.paginator.pageIndex != this.lastPage || this.paginator.pageSize != this.lastPageSize) {
            this.lastPage = this.paginator.pageIndex
            this.lastPageSize = this.paginator.pageSize
            this.consultar()
          }
        })
      )
      .subscribe()

    this.consultar()
  }

  tipoAndamentoTexto(str?: string): string {
    if (typeof str === 'undefined' || str == null || str == '') return ''
    return (TipoAcaoOperacao as any)[str]
  }

  private filtros() {
    let usuario: string | null = this.usuarioFC.value as string
    let id: number | null = this.idFC.value as number

    if (id === null) {
      this.idFC.setValue('')
    }

    if (usuario && usuario.trim()) usuario = usuario.trim()
    else usuario = null

    return {
      nivel: this.nivelLogFC.value == 'TODOS' ? null : this.nivelLogFC.value,
      dataInicio: this.dataInicialFC.value ? this.dataInicialFC.value : null,
      dataFinal: this.dataFinalFC.value ? this.dataFinalFC.value : null,
      usuario,
      id,
      acaoOp: this.tipoAcaoOperacaoFC.value == 'TODOS' ? null : (this.tipoAcaoOperacaoFC.value as string).slice(4),
      acaoReg: this.tipoAcaoRefToFC.value == 'TODOS' ? null : (this.tipoAcaoRefToFC.value as string).slice(4),
      registro: this.registro,
      ip: this.ipAddr,
    }
  }

  private consultar() {
    this.consultaLogService
      .listar(this.paginator.pageIndex, this.paginator.pageSize, this.filtros())
      .subscribe(page => {
        this.dataSource = new MatTableDataSource(page['content'])
        this.totalElements = page['totalElements']
        this.paginator._changePageSize(page['pageable']['pageSize'])
      })
  }

  consultarBtnClick() {
    this.paginator.pageIndex = 0
    this.ipAddr = null
    this.registro = null
    this.msgSelecionado = ''
    this.consultar()
  }

  getAcaoDescricaoTxt = getAcaoDescricaoTxt

  abrirDetalhes(log: LogEntry) {
    this.dialog.open(LogDetalhesComponent, { data: log, width: '90%' })
  }

  clearDate(): void {
    this.dataInicialFC.setValue(null)
    this.dataFinalFC.setValue(null)
  }
}
